@if (resource) {
<div class="title" [ngClass]="{'title--active': isActive}">
    <span class="title__text">{{ resource.getName() }}</span>
</div>
<app-resource-toggle
    [resource]="resource"
    (changed)="handleChange()"
></app-resource-toggle>
}
